import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import RefundPolicy from "./pages/RefundPolicy";
import TermsOfService from "./pages/TermsOfService";
import Contact from "./pages/Contact";
import About from "./pages/About";
import Career from "./pages/Career";
import DataAnalystCourse from "./pages/DataAnalystCourse";
import AgenticAICourse from "./pages/AgenticAICourse";
import GenerativeAICourse from "./pages/GenerativeAICourse";
import ScrollToTop from "./components/ScrollToTop";
import { initFacebookPixel, trackPageView } from "./lib/fpixel";

const queryClient = new QueryClient();

// Initialize Facebook Pixel
initFacebookPixel();

// Route change tracker component
const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView();
  }, [location]);

  return null;
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <RouteChangeTracker />
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/data-analyst-course" element={<DataAnalystCourse />} />
          <Route path="/agentic-ai-course" element={<AgenticAICourse />} />
          <Route path="/generative-ai-course" element={<GenerativeAICourse />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/career" element={<Career />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
